import {useTranslation} from 'react-i18next';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import {graphqlClient} from '@/services/graphqlClient';
import {useGetWarehousesForExportQuery} from '@/services/graphqlHooks';

import type {ExportOptionsFieldsProps} from '../../types/exportTypes';
import type {InventoryOptions} from '../../utils/definitions/inventoryExport';

const InventoryOptionsFields = ({
  form,
}: ExportOptionsFieldsProps<InventoryOptions>) => {
  const {t} = useTranslation();
  const {data} = useGetWarehousesForExportQuery(graphqlClient);
  const warehouses = data?.getWarehouses ?? [];

  return (
    <FormField
      control={form.control}
      name="options.warehouseId"
      render={({field}) => (
        <FormItem>
          <FormLabel required>{t('Warehouse')}</FormLabel>
          <Select value={field.value} onValueChange={field.onChange}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={t('Select warehouse')} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {warehouses.map(warehouse => (
                <SelectItem key={warehouse.id} value={warehouse.id}>
                  {warehouse.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default InventoryOptionsFields;
